/* eslint prefer-const: 0 */
import { DEV } from './config';
import TRACKING_CONFIG from './tracking-map';


const LOGGING_ENABLED = DEV;

const TRACKING_TEMPLATE_CODES = {
  '[[INDEX]]': 'index',
};

class Tracking {
  /**
   * Log tracking info for debugging / testing
   *
   * @param {any} params
   *
   * @memberof Tracking
   */
  static log(...params) {
    if (LOGGING_ENABLED) {
      console.info('Tracking:', ...params);
    }
  }

  /**
   * Get the config for a tracking id
   *
   * @static
   * @param {any} id
   * @returns
   *
   * @memberof Tracking
   */
  static getConfig(id) {
    if (!TRACKING_CONFIG[id]) {
      throw new Error(`Invalid tracking id: ${id}`);
    }
    return TRACKING_CONFIG[id];
  }

  /**
   * Pattern to find template codes in label
   *
   * @static
   *
   * @memberof Tracking
   */
  static TEMPLATE_TOKEN_PATTERN = /\[\[[A-Z_,0-9/]+\]\]/g;

  /**
   * Render the label with the data
   *
   * @static
   * @param {String} template
   * @param {Object} data
   * @returns {String}
   *
   * @memberof Tracking
   */
  static getLabel(template, data) {
    return template.replace(Tracking.TEMPLATE_TOKEN_PATTERN, Tracking.$renderLabelSegment.bind(null, data));
  }

  /**
   * String replace function for `Tracking.getLabel`
   *
   * @static
   * @param {any} data
   * @param {string} match
   * @returns {String}
   *
   * @memberof Tracking
   */
  static $renderLabelSegment(data, match) {
    let str = data[TRACKING_TEMPLATE_CODES[match]];
    return str || '';
  }

  /**
   * Wrap google analytics tracker `window.ga`
   *
   * @param {any} params
   *
   * @memberof Tracking
   */
  ga(...params) { // eslint-disable-line
    Tracking.log(params);

    if (!window.ga && !DEV) {
      throw new Error('No GA found for tracking');
    }
    window.ga(...params);
  }

  /**
   * Wrap facebook tracker `window.fqb`
   *
   * @param {string} label
   * @memberof Tracking
   */
  fb(label) { // eslint-disable-line
    Tracking.log('FB', label);

    if (!window.fbq) {
      throw new Error('No FBQ found for tracking');
    }
    window.fbq('track', label);
  }

  /**
   * Wrap twitter tracker `window.twttr.conversion`
   *
   * @param {*} label
   * @memberof Tracking
   */
  twitter(label) { // eslint-disable-line
    Tracking.log('TWITTER', label);

    if (!window.twttr) {
      throw new Error('No TWTTR found for tracking');
    }
    window.twttr.conversion.trackPid(label, { tw_sale_amount: 0, tw_order_quantity: 0 });
  }

  /**
   * Wrap google tag manager `window.gtag`
   *
   * @param {*} data
   * @memberof Tracking
   */
  gtag(data) { // eslint-disable-line
    Tracking.log('GTAG', data);
    if (!window.gtag) {
      throw new Error('no GTAG found for tracking');
    }

    window.gtag('event', 'conversion', data);
  }

  /**
   * Track an event using Id
   *
   * @param {string} id
   *
   * @memberof Tracking
   */
  trackEvent(id) {
    const { fb, twitter, gtag } = Tracking.getConfig(id);

    if (fb) {
      this.fb(fb);
    }

    if (twitter) {
      this.twitter(twitter);
    }

    if (gtag) {
      this.gtag(gtag);
    }
  }
}

export default new Tracking();
